export const instagramLink = "https://www.instagram.com/youcandoitgardening/";
export const youtubeLink = "https://www.youtube.com/@youcandoitgardening";
export const tiktokLink = "https://www.tiktok.com/@youcandoitgardening";
export const facebookLink = "https://www.facebook.com/youcandoitgardencoaching";

export const mailingListLink = "https://stan.store/youcandoitgardening/p/sign-up-for-my-newsletter-7u3ab6vl";
export const contactMeLink = "https://sites.google.com/view/youcandoitgardening/contact-me-by-phone";

export const scheduleInPersonLink = "https://docs.google.com/forms/d/e/1FAIpQLSdRKfkhQgWNoDH7D6POnLhlApjlH82puI6B02BjNTlMcGbjIA/viewform";
export const scheduleOnlineLink = "https://youcandoitgardening.as.me/schedule.php";